import React, { useState, useEffect, useCallback, } from "react";
import { useBNIdentity } from "@gw/bn-identity";
import { Loader, ButtonLink, TableDeleteButton, useModals, ModalDelete, useNotificationsCtx, TNotificationType, } from "@gw/component-library";
import { UserListStyled } from "./UserListStyled";
import { Link } from "@reach/router";
var UserList = function (props) {
    var _a = useBNIdentity(), listUsers = _a.listUsers, deleteUser = _a.deleteUser;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState([]), users = _c[0], setUsers = _c[1];
    var _d = useModals(), openModal = _d.openModal, closeModal = _d.closeModal;
    var addNotification = useNotificationsCtx().addNotification;
    useEffect(function () {
        try {
            listUsers().then(function (users) {
                setUsers(users);
                setIsLoading(false);
            });
        }
        catch (err) {
            setIsLoading(false);
        }
    }, [listUsers]);
    var deleteUserCb = useCallback(function (userId) {
        deleteUser(userId)
            .then(function (deletedUser) {
            addNotification("User Deleted!", TNotificationType.success);
            var newUsers = users.filter(function (u) { return u.id !== deletedUser.id; });
            setUsers(newUsers);
        })
            .catch(function () {
            addNotification("Error Deleting User!", TNotificationType.error);
        });
    }, [users, deleteUser, addNotification]);
    var openDeleteModal = function (userId) {
        var modalId = "delete-" + userId;
        openModal(modalId, "", React.createElement(ModalDelete, { modalId: modalId, title: "Are you sure?", note: "This is a destructive action that has no way of being reversed. Do you really want to delete this user?", onDelete: function () { return deleteUserCb(userId); }, closeModal: function (modalId) { return closeModal(modalId); } }));
    };
    if (isLoading) {
        return React.createElement(Loader, null);
    }
    if (users.length === 0) {
        return React.createElement("div", null, "No users found");
    }
    return (React.createElement(UserListStyled, null,
        React.createElement("div", { className: "actions" },
            React.createElement(ButtonLink, { to: "/admin/users/create" }, "New User")),
        React.createElement("div", { className: "table-container" },
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Email"),
                        React.createElement("th", null, "Name"),
                        React.createElement("th", null, "Role"),
                        React.createElement("th", null, "Confirmed"),
                        React.createElement("th", null, "Last Logged In"),
                        React.createElement("th", null, "Actions"))),
                React.createElement("tbody", null, users.map(function (user) {
                    return (React.createElement("tr", { key: user.id },
                        React.createElement("td", null,
                            React.createElement(Link, { to: "/admin/users/" + user.id },
                                user.first_name,
                                " ",
                                user.last_name)),
                        React.createElement("td", null, user.bn_role),
                        React.createElement("td", null, user.email),
                        React.createElement("td", null, user.confirmed ? "Yes" : "No"),
                        React.createElement("td", null, user.last_logged_in
                            ? user.last_logged_in.toLocaleDateString()
                            : "N/A"),
                        React.createElement("td", null,
                            React.createElement(TableDeleteButton, { id: "" + user.id, onDelete: openDeleteModal }))));
                }))))));
};
export default UserList;
//# sourceMappingURL=UserList.js.map